import { blobToBase64 } from "./reportUtils";
export const getFile = async (file: File, id: any | undefined = null) => {
    const name = file.name;
    const extension = name.split('.').pop();
    const base64 = await blobToBase64(file);
    return { name, extension, base64, id };
}

export const getFileExt = (dataURL: string, defaultFileName: string) => {
    const matches = dataURL.match(/^data:([^;]+);base64,/);
    if (!matches) {
        throw new Error("Formato Base64 inválido.");
    }

    const mimeType = matches[1]; // Obtém o MIME type
    const extMap: Record<string, string> = {
        "application/pdf": "pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
        "application/msword": "doc",
        "application/vnd.ms-excel": "xls",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
        "image/jpeg": "jpg",
        "image/png": "png",
        "text/plain": "txt",
    };

    const ext = extMap[mimeType] || "bin";
    const fileName = defaultFileName.replace(/\.pdf$/, `.${ext}`);

    const byteString = atob(dataURL.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
    }

    return new File([uint8Array], fileName, { type: mimeType }).name;
};

export const dataURLtoFile = (dataurl: any, filename: any) => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}